import React from 'react';
import { TitleMenu } from './tabmenu';

/**
 * タブメニュー・ヘッダ
 * @param height ヘッダの高さ
 * @returns 
 */
export const TitlePage: React.FC<{ height: number }> = ({ height }) => {
  return (
    <TitleMenu height={height} />
  );
};
